<div class="comm-dashboard">

	<div class="dashboard-status" *ngIf="loading">Loading dashboard…</div>
	<div class="dashboard-status error" *ngIf="loadError">
		Unable to load the dashboard. <button type="button" (click)="reload()">Retry</button>
	</div>

	<ng-container *ngIf="!loading && !loadError">

	<div class="period-toggle">
		<button [class.active]="period === 'week'" (click)="setPeriod('week')">Wk</button>
		<button [class.active]="period === 'month'" (click)="setPeriod('month')">Mo</button>
	</div>

	<!-- ── Charts Row ─────────────────────────────────────────────────── -->
	<div class="chart-panels" *ngIf="emailChart && smsChart">

		<!-- Email Panel -->
		<div class="chart-panel">
			<div class="panel-header">
				<span class="material-symbols-outlined">email</span>
				Email Activity
			</div>

			<div class="stat-strip">
				<div class="stat-item">
					<span class="stat-label">REQUESTS</span>
					<span class="stat-value">{{ emailStats.requests | number }}</span>
				</div>
				<div class="stat-item delivered">
					<span class="stat-label">DELIVERED</span>
					<span class="stat-value">{{ emailStats.deliveredPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ emailStats.delivered | number }}</span>
				</div>
				<div class="stat-item opened">
					<span class="stat-label">OPENED</span>
					<span class="stat-value">{{ emailStats.openedPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ emailStats.opened | number }}</span>
				</div>
				<div class="stat-item clicked">
					<span class="stat-label">CLICKED</span>
					<span class="stat-value">{{ emailStats.clickedPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ emailStats.clicked | number }}</span>
				</div>
				<div class="stat-item bounced">
					<span class="stat-label">BOUNCES</span>
					<span class="stat-value">{{ emailStats.bouncesPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ emailStats.bounces | number }}</span>
				</div>
				<div class="stat-item spam">
					<span class="stat-label">SPAM</span>
					<span class="stat-value">{{ emailStats.spamPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ emailStats.spamReports | number }}</span>
				</div>
				<div class="stat-item unsubscribed">
					<span class="stat-label">UNSUBS</span>
					<span class="stat-value">{{ emailStats.unsubscribedPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ emailStats.unsubscribed | number }}</span>
				</div>
			</div>

			<div class="chart-container">
				<svg viewBox="0 0 480 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
					<!-- Grid lines -->
					<g *ngFor="let g of emailChart.gridLines">
						<line x1="55" [attr.x2]="470" [attr.y1]="g.y" [attr.y2]="g.y" class="grid-line" />
						<text x="48" [attr.y]="g.y + 4" class="y-label">{{ g.label }}</text>
					</g>
					<!-- X-axis labels -->
					<text *ngFor="let xl of emailChart.xLabels" [attr.x]="xl.x" y="185" class="x-label">{{ xl.label }}</text>
					<!-- Area fills -->
					<polygon *ngFor="let s of emailChart.series"
						[attr.points]="s.areaPoints"
						[attr.fill]="s.color"
						fill-opacity="0.07" />
					<!-- Lines -->
					<polyline *ngFor="let s of emailChart.series"
						[attr.points]="s.points"
						[attr.stroke]="s.color"
						fill="none"
						stroke-width="2.5"
						stroke-linecap="round"
						stroke-linejoin="round" />
					<!-- Dots -->
					<ng-container *ngFor="let s of emailChart.series">
						<circle *ngFor="let d of s.dots"
							[attr.cx]="d.x" [attr.cy]="d.y" r="3.5"
							[attr.fill]="s.color"
							stroke="white" stroke-width="1.5" />
					</ng-container>
				</svg>
			</div>

			<div class="legend">
				<span *ngFor="let s of emailChart.series" class="legend-item">
					<span class="legend-dot" [style.background]="s.color"></span>
					{{ s.label }}
				</span>
			</div>
		</div>

		<!-- SMS Panel -->
		<div class="chart-panel">
			<div class="panel-header">
				<span class="material-symbols-outlined">sms</span>
				SMS Activity
			</div>

			<div class="stat-strip">
				<div class="stat-item">
					<span class="stat-label">SENT</span>
					<span class="stat-value">{{ smsStats.sent | number }}</span>
				</div>
				<div class="stat-item delivered">
					<span class="stat-label">DELIVERED</span>
					<span class="stat-value">{{ smsStats.deliveredPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ smsStats.delivered | number }}</span>
				</div>
				<div class="stat-item bounced">
					<span class="stat-label">UNDELIVERED</span>
					<span class="stat-value">{{ smsStats.undeliveredPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ smsStats.undelivered | number }}</span>
				</div>
				<div class="stat-item spam">
					<span class="stat-label">FAILED</span>
					<span class="stat-value">{{ smsStats.failedPct | number:'1.1-1' }}%</span>
					<span class="stat-sub">{{ smsStats.failed | number }}</span>
				</div>
			</div>

			<div class="chart-container">
				<svg viewBox="0 0 480 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
					<g *ngFor="let g of smsChart.gridLines">
						<line x1="55" [attr.x2]="470" [attr.y1]="g.y" [attr.y2]="g.y" class="grid-line" />
						<text x="48" [attr.y]="g.y + 4" class="y-label">{{ g.label }}</text>
					</g>
					<text *ngFor="let xl of smsChart.xLabels" [attr.x]="xl.x" y="185" class="x-label">{{ xl.label }}</text>
					<polygon *ngFor="let s of smsChart.series"
						[attr.points]="s.areaPoints"
						[attr.fill]="s.color"
						fill-opacity="0.07" />
					<polyline *ngFor="let s of smsChart.series"
						[attr.points]="s.points"
						[attr.stroke]="s.color"
						fill="none"
						stroke-width="2.5"
						stroke-linecap="round"
						stroke-linejoin="round" />
					<ng-container *ngFor="let s of smsChart.series">
						<circle *ngFor="let d of s.dots"
							[attr.cx]="d.x" [attr.cy]="d.y" r="3.5"
							[attr.fill]="s.color"
							stroke="white" stroke-width="1.5" />
					</ng-container>
				</svg>
			</div>

			<div class="legend">
				<span *ngFor="let s of smsChart.series" class="legend-item">
					<span class="legend-dot" [style.background]="s.color"></span>
					{{ s.label }}
				</span>
			</div>
		</div>

	</div>

	<!-- ── Employer Table ─────────────────────────────────────────────── -->
	<div class="section-header">
		<span class="material-symbols-outlined">groups_2</span>
		Employer Performance
	</div>

	<div class="employer-grid">
		<div class="header sortable" (click)="sortEmployers('name')">
			Employer <span class="sort-icon" [ngClass]="getSortIcon('name')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('stage')">
			Stage <span class="sort-icon" [ngClass]="getSortIcon('stage')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('campaigns')">
			Drip Campaigns <span class="sort-icon" [ngClass]="getSortIcon('campaigns')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('censusLoaded')">
			Census Recs <span class="sort-icon" [ngClass]="getSortIcon('censusLoaded')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('commPreference')">
			Comm Pref <span class="sort-icon" [ngClass]="getSortIcon('commPreference')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('dripStartDate')">
			Drip Start <span class="sort-icon" [ngClass]="getSortIcon('dripStartDate')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('lastCampaign')">
			Last Drip <span class="sort-icon" [ngClass]="getSortIcon('lastCampaign')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('nextCampaign')">
			Next Drip <span class="sort-icon" [ngClass]="getSortIcon('nextCampaign')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('emailDeliveredPct')">
			Email Del. <span class="sort-icon" [ngClass]="getSortIcon('emailDeliveredPct')"></span>
		</div>
		<div class="header sortable" (click)="sortEmployers('smsDeliveredPct')">
			SMS Del. <span class="sort-icon" [ngClass]="getSortIcon('smsDeliveredPct')"></span>
		</div>
		<div class="header">Status</div>

		<ng-container *ngFor="let emp of employers">
			<div class="cell name-cell" (click)="openEmployer(emp)">
				<a>{{ emp.name }}</a>
			</div>
			<div class="cell center">
				<span class="stage-badge" [ngClass]="getStage(emp)">
					<span class="stage-dot"></span>{{ getStageLabel(getStage(emp)) }}
				</span>
			</div>
			<div class="cell center">{{ emp.campaignsSent }}/{{ emp.campaignsTotal }}</div>
			<div class="cell center" [ngClass]="{ 'rate-warn': emp.censusLoaded === 0 }">
				<ng-container *ngIf="emp.censusLoaded > 0; else dashCell">{{ emp.censusLoaded | number }}</ng-container>
			</div>
			<div class="cell comm-pref">
				<span class="material-symbols-outlined" [title]="getCommPrefLabel(emp.commPreference)">{{ getCommPrefIcon(emp.commPreference) }}</span>
				<span class="comm-pref-label">{{ getCommPrefLabel(emp.commPreference) }}</span>
			</div>
			<div class="cell center" [ngClass]="{ 'rate-warn': !emp.dripStartDate }">
				<ng-container *ngIf="emp.dripStartDate; else dashCell">{{ emp.dripStartDate | date:'MM/dd/yyyy' }}</ng-container>
			</div>
			<div class="cell center">
				<ng-container *ngIf="emp.lastCampaign; else dashCell">{{ emp.lastCampaign | date:'MM/dd/yyyy' }}</ng-container>
			</div>
			<div class="cell center">
				<ng-container *ngIf="emp.nextCampaign; else dashCell">{{ emp.nextCampaign | date:'MM/dd/yyyy' }}</ng-container>
			</div>
			<div class="cell center" [ngClass]="{ 'rate-warn': emp.emailDeliveredPct != null && emp.emailDeliveredPct < 95 }">
				<ng-container *ngIf="emp.emailDeliveredPct != null; else dashCell">{{ emp.emailDeliveredPct | number:'1.1-1' }}%</ng-container>
			</div>
			<div class="cell center" [ngClass]="{ 'rate-warn': emp.smsDeliveredPct != null && emp.smsDeliveredPct < 95 }">
				<ng-container *ngIf="emp.smsDeliveredPct != null; else dashCell">{{ emp.smsDeliveredPct | number:'1.1-1' }}%</ng-container>
			</div>
			<div class="cell center">
				<span class="status-badge" [ngClass]="getStatus(emp)">
					<span class="material-symbols-outlined">{{ getStatus(emp) === 'ok' ? 'check_circle' : 'warning' }}</span>
					{{ getStatus(emp) === 'ok' ? 'All Good' : 'Review' }}
				</span>
			</div>
		</ng-container>
	</div>

	<ng-template #dashCell><span class="text-muted">—</span></ng-template>

	</ng-container>

</div>
